/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Form_Start_Chat_Project_ModeInputs */



/**
* | output |
* | --- |
* | "Project" |
*
* @param {Form_Start_Chat_Project_ModeInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const form_start_chat_project_mode = /** @type {((inputs?: Form_Start_Chat_Project_ModeInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Form_Start_Chat_Project_ModeInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Projekt")
	return /** @type {LocalizedString} */ ("Project")
});